import { render, staticRenderFns } from "./BNavigation.vue?vue&type=template&id=bc4b4a72&scoped=true"
import script from "./BNavigation.vue?vue&type=script&lang=js"
export * from "./BNavigation.vue?vue&type=script&lang=js"
import style0 from "./BNavigation.vue?vue&type=style&index=0&id=bc4b4a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4b4a72",
  null
  
)

export default component.exports